const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  require('cloud-utils/config/events/default.json').deviceEventSettings
)
const { LOAD_DEVICE_DETAILS } = require('../../constants/commonEvents')
const SemVerLte = require('semver/functions/lte')
angular
  .module('surfsightApp.controllers')
  .controller('eventsDashboardController', [
    '$scope',
    '$state',
    '$stateParams',
    '$timeout',
    '$http',
    '$filter',
    '$localStorage',
    '$mdToast',
    'edgeFactoryV2',
    'SystemConstants',
    'UnitSystem',
    function (
      $scope,
      $state,
      $stateParams,
      $timeout,
      $http,
      $filter,
      $localStorage,
      $mdToast,
      edgeFactoryV2,
      SystemConstants,
      UnitSystem
    ) {
      const $translate = $filter('translate')

      $scope.avg_speed = 0
      $scope.max_speed = 0
      $scope.min_speed = 0
      $scope.distance = 0
      $scope.TotalEventsCount = 0
      $scope.units = 0
      $scope.eventSearch = {
        id: 1,
        name: Date.today().toString('dddd, dd MMM yyyy'),
        name_formate1: 'today',
        name_formate2: Date.today().toString('MMM dd '),
        date: {
          start: Date.today().getTime(),
          end: Date.today()
            .add(1)
            .day()
            .getTime()
        }
      }

      // todo: As this call is not migrated yet we leave it as it is.
      $scope.getEdgeSpeed = edge => {
        // todo: After switching to edgeFactoryV2 device (edge) doesn't have id field. V2 endpoints relay on IMEI
        // todo: How to get device ID to be able to still invoke /speed v1 endpoint
        $scope.selected_gps_events_edge = edge
        const data = {
          last_know_id: 0,
          number_of_records: 0,
          time_range: {
            start: $scope.eventSearch.date.start / 1000,
            end: $scope.eventSearch.date.end / 1000
          }
        }
        // todo: Once this call will be migrated, change it to V2
        edgeFactoryV2
          .getEdgeSpeed(data, $scope.serialNumber)
          .then(
            ({
              avg_speed,
              distance,
              max_speed,
              min_speed,
              status: { code },
              units
            }) => {
              $scope.dashboard_loading = false
              if (code === 0) {
                $scope.avg_speed = Math.round(avg_speed * 3.6 * 10) / 10 // Math.round(location.speed*3.6 * 10) / 10
                $scope.max_speed = Math.round(max_speed * 3.6 * 10) / 10
                $scope.min_speed = Math.round(min_speed * 3.6 * 10) / 10
                $scope.distance = parseFloat((distance * 1.609344).toFixed(2))
                $scope.units = units
              } else {
                $scope.avg_speed = 0
                $scope.max_speed = 0
                $scope.min_speed = 0
                $scope.distance = 0
                $scope.units = 0
              }
            }
          )
      }

      $scope.getEdge = imei => {
        const { item } = edgeFactoryV2.findItemByImei(imei)
        if (item) {
          $scope.edge = item
          $scope.serialNumber = item.imei
          $scope.semanticVersion = item.firmwareVersion
          loadData()
        }
      }

      $scope.loadEdge = deviceImei => {
        let { imei } = $stateParams
        if (deviceImei) {
          imei = deviceImei
        }

        $scope.getEdge(imei)
        if (!$scope.edge) {
          $scope.$emit(LOAD_DEVICE_DETAILS.REQUEST, {
            imei
          })
          $scope.$on(
            LOAD_DEVICE_DETAILS.RESPONSE,
            (e, { imei: deviceImei }) => {
              $scope.loadEdge(deviceImei)
            }
          )
        }
      }

      $scope.loadEdge()

      function loadData () {
        var edge = $scope.edge
        $scope.edge_events = []
        $scope.avg_speed = 0
        $scope.max_speed = 0
        $scope.min_speed = 0
        $scope.distance = 0
        $scope.TotalEventsCount = 0
        $scope.units = 0
        $scope.pattern = ''
        $scope.currentState = $state.current.name
        $scope.xValues =
          '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24' // move to const
        $scope.resetEventSearch = function () {
          $scope.eventSearch = {
            id: 1,
            name: Date.today().toString('dddd, dd MMM yyyy'),
            name_formate1: 'today',
            name_formate2: Date.today().toString('MMM dd '),
            date: {
              start: Date.today().getTime(),
              end: Date.today()
                .add(1)
                .day()
                .getTime()
            }
          }
        }
        if ($scope.currentState === 'home.common.events.history') {
          // move to const
          $scope.resetEventSearch()
        } else {
          $scope.eventSearch = $stateParams.eventSearch
        }

        $scope.getEdgeEvents = async () => {
          $scope.selected_gps_events_edge = edge

          edgeFactoryV2
            .getDeviceEvents(
              $scope.serialNumber,
              moment($scope.eventSearch.date.start).format(),
              moment($scope.eventSearch.date.end).format()
            )
            .then(
              data => {
                $scope.edge_events = data
                $scope.updateEdgeEventStastics()
                $scope.UpdateChartData(data)
              },
              function (response) {
                $scope.edge_events = []
                $scope.updateEdgeEventStastics()
                $scope.UpdateChartData([])
                handleServerError(response)
              }
            )
        }
        $scope.existEvents = deviceEventSettings.filter(
          e =>
            (e.fromVersion
              ? edge.firmwareVersion &&
                SemVerLte(e.fromVersion, edge.firmwareVersion)
              : true) &&
            (e.toVersion
              ? edge.firmwareVersion &&
                SemVerLte(edge.firmwareVersion, e.toVersion)
              : true) &&
            ($scope.semanticVersion >= 3 ||
              ['distracted_driving', 'cover_opened'].indexOf(e.v2Name) === -1)
        )
        var comma = '' // refactor it
        $scope.updateEdgeEventStastics = function () {
          var countsObject = {}
          $scope.TotalEventsCount = 0
          $scope.existEvents.forEach(function (ev, i) {
            countsObject[ev.v2Name] = 0
            $scope.existEvents[i].yData = []
            if ($scope.pattern.trim() != '') {
              comma = ','
            }
            $scope.pattern = $scope.pattern + '' + comma + '' + ev.icon.color
          })
          $scope.edge_events.forEach(function (event) {
            countsObject[event.eventType]++
          })
          $scope.existEvents.forEach(function (ev, i) {
            $scope.existEvents[i].count = countsObject[ev.v2Name]
            $scope.TotalEventsCount =
              $scope.TotalEventsCount + $scope.existEvents[i].count
          })
        }

        $scope.UpdateChartData = function (edgeEvents) {
          $scope.xValues_array = []
          $scope.yValues_array = []
          $scope.xColumeName_array = []
          $scope.xColumeID_array = []
          $scope.datapoints = []
          $scope.datacolumns = []
          $scope.yValues_object = {}
          $scope.existEvents.forEach(function (e, i) {
            $scope.yValues_object[$translate(e.translate_name)] = []
            $scope.existEvents[i].yData = []
            $scope.datapoints = []
            $scope.xColumeName_array.push(
              $translate($scope.existEvents[i].translate_name)
            )
            $scope.xColumeID_array.push($scope.existEvents[i].name)
          })
          $scope.xColumeName = $scope.xColumeName_array.toString()
          $scope.xColumeID = $scope.xColumeID_array.toString()
          startDate = $scope.eventSearch.date.start
          endDate = $scope.eventSearch.date.end
          if (
            $scope.eventSearch.id === 1 ||
            $scope.eventSearch.id === 2 ||
            $scope.eventSearch.differenceDays === 1
          ) {
            for (var k = 1; k <= 24; k++) {
              var hour = new Date(startDate)
                .add(k)
                .hour()
                .toString('H')
              $scope.xValues_array.push(hour)
              $scope.yValues_array.push(0)
              Object.keys($scope.yValues_object).forEach(function (key) {
                $scope.yValues_object[key].push(0)
              })
            }
            edgeEvents.forEach(function (e) {
              var hour = new Date(e.time).toString('H')
              var hour_index = $scope.xValues_array.indexOf(hour)
              $scope.yValues_array[hour_index]++
              $scope.existEvents.forEach(function (ev) {
                if (ev.v2Name === e.eventType) {
                  $scope.yValues_object[$translate(ev.translate_name)][
                    hour_index
                  ]++
                }
              })
            })
          } else {
            var timeDiff = Math.abs(
              new Date(endDate).getTime() - new Date(startDate).getTime()
            )

            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
            for (var j = 0; j < diffDays; j++) {
              var getDate = new Date(startDate)
                .add(j)
                .day()
                .toString('dd-MM-yyyy')
              $scope.xValues_array.push(getDate)
              $scope.yValues_array.push(0)
              Object.keys($scope.yValues_object).forEach(function (key) {
                $scope.yValues_object[key].push(0)
              })
            }
            edgeEvents.forEach(function (e) {
              var getDate = new Date(e.time).toString('dd-MM-yyyy')
              var date_index = $scope.xValues_array.indexOf(getDate)
              $scope.yValues_array[date_index]++
              $scope.existEvents.forEach(function (ev) {
                if (ev.v2Name === e.eventType) {
                  $scope.yValues_object[$translate(ev.translate_name)][
                    date_index
                  ]++
                }
              })
            })
          }

          $scope.xValues = '"' + $scope.xValues_array.toString() + '"'
          var data_column_obj = {}

          $scope.existEvents.forEach(function (ev, i) {
            data_column_obj.type = 'line'
            $scope.existEvents[i].yData =
              $scope.yValues_object[
                $translate($scope.existEvents[i].translate_name)
              ]
            $scope.datacolumns.push({
              id: $translate(ev.translate_name),
              type: 'line'
            })
          })
          $scope.xValues_array.forEach(function (x, i) {
            var tmp_obj = {}
            tmp_obj.x = x
            if (
              $scope.eventSearch.id === 1 ||
              $scope.eventSearch.id === 2 ||
              $scope.eventSearch.differenceDays === 1
            ) {
              tmp_obj.x = x + 'hr'
              if (x == 0) {
                tmp_obj.x = '24' + 'hr'
              }
            }
            $scope.existEvents.forEach(function (e) {
              tmp_obj[$translate(e.translate_name)] = e.yData[i]
            })
            $scope.datapoints.push(tmp_obj)
          })
        }

        $scope.getEdgeEvents()
        $scope.$on('eventSearchDataResult', function (e, data) {
          $scope.dashboard_loading = true
          const startDate = moment(data.eventSearchData.response.date.start)
          const endDate = moment(data.eventSearchData.response.date.end)
          const differenceDays = endDate.diff(startDate, 'days')
          $scope.eventSearch = data.eventSearchData.response
          $scope.eventSearch.differenceDays = parseInt(differenceDays)
          $scope.getEdgeEvents()
          $scope.getEdgeSpeed(edge)
        })
        $scope.datax = {
          id: 'x'
        }

        $scope.datacolumns2 = [
          {
            id: 'button',
            type: 'line'
          },
          {
            id: 'de_acceleration',
            type: 'line'
          },
          {
            id: 'acceleration',
            type: 'line'
          },
          {
            id: 'sharp_turn_left',
            type: 'line'
          },
          {
            id: 'sharp_turn_right',
            type: 'line'
          }
        ]
        $scope.datapoints2 = [
          {
            x: new Date()
              .add(1)
              .day()
              .toString('dd-MM-yyyy'),
            button: 0,
            de_acceleration: 0,
            acceleration: 0,
            sharp_turn_left: 0,
            sharp_turn_right: 0
          },
          {
            x: new Date().toString('dd-MM-yyyy'),
            button: 10,
            de_acceleration: 7,
            acceleration: 20,
            sharp_turn_left: 0,
            sharp_turn_right: 0
          },
          {
            x: new Date()
              .add(2)
              .day()
              .toString('dd-MM-yyyy'),
            button: 13,
            de_acceleration: 2,
            acceleration: 2,
            sharp_turn_left: 4,
            sharp_turn_right: 2
          },
          {
            x: new Date()
              .add(3)
              .day()
              .toString('dd-MM-yyyy'),
            button: 103,
            de_acceleration: 5,
            acceleration: 5,
            sharp_turn_left: 27,
            sharp_turn_right: 24
          },
          {
            x: new Date()
              .add(4)
              .day()
              .toString('dd-MM-yyyy'),
            button: 15,
            de_acceleration: 1,
            acceleration: 0,
            sharp_turn_left: 1,
            sharp_turn_right: 1
          },
          {
            x: new Date()
              .add(5)
              .day()
              .toString('dd-MM-yyyy'),
            button: 8,
            de_acceleration: 2,
            acceleration: 0,
            sharp_turn_left: 6,
            sharp_turn_right: 5
          },
          {
            x: new Date()
              .add(6)
              .day()
              .toString('dd-MM-yyyy'),
            button: 0,
            de_acceleration: 0,
            acceleration: 0,
            sharp_turn_left: 0,
            sharp_turn_right: 0
          }
        ]
        $scope.getEdgeSpeed(edge)
      }

      function handleServerError (response) {
        if (response && response.data) {
          $scope.showMessageToast(response.data.message)
        } else {
          $scope.showMessageToast($translate('errorOccurred'))
        }
      }

      $scope.showMessageToast = message => {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('top right')
          .actionKey('F1')
          .hideDelay(5000)
        $mdToast
          .show(toast)
          .then(response => {
            if (response === 'ok') {
              // alert('You clicked the \'UNDO\' action.');
            }
          })
          .catch(() => {})
      }

      $scope.toggle_c3_chart = true
      $scope.$on('languageChange', function (e, data) {
        $scope.datacolumns = []
        $scope.toggle_c3_chart = false
        $timeout(function () {
          $scope.toggle_c3_chart = true
        })
        var data_column_obj = {}
        $scope.existEvents.forEach(function (ev, i) {
          data_column_obj.type = 'line'
          $scope.existEvents[i].yData =
            $scope.yValues_object[
              $translate($scope.existEvents[i].translate_name)
            ]
          $scope.datacolumns.push({
            id: $translate(ev.translate_name),
            type: 'line'
          })
        })
        $scope.UpdateChartData($scope.edge_events)
      })
      $scope.UnitSystem = UnitSystem
      if ($localStorage.measurementUnits === 1) {
        SystemConstants.unit = 1
      } else {
        SystemConstants.unit = 0
      }
    }
  ])
